<template>
  <div class="add-page" style="height: 100vh;padding: 20px">
    <div>
      <div style="margin-bottom: 10px;">
        <el-button size="medium" @click="$router.push({path:'/order/examined-Information',query:$route.query})">返回</el-button>
      </div>
      <div v-if="form.auditStatus == 2" class="text-right" style="margin-bottom: 10px;">
        <el-button size="primary" @click="save">审核通过</el-button>
        <el-button size="medium" @click="edit()">审核不通过</el-button>
      </div>
      <div style="margin-bottom: 10px;">
        <div>
          审核状态：<span>{{$enums.auditStatus2[form.auditStatus]}}</span>
        </div>
        <span v-if="form.auditRemark">原因： {{form.auditRemark}}</span>
      </div>
      <div>
        <div style="margin-bottom: 10px;">费用内容</div>
        <table class="tab" style="width: 100%;text-align: center;border: 1px solid #e6e6e6;">
          <thead>
          <tr>
            <th>考试名称</th>
            <th>承办单位</th>
            <th>考生报名总人数</th>
            <th>实际应收报名总费用</th>
            <th>分账比例</th>
            <th>实际应交川音报名总费用</th>
            <th>上报时间</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{form.batchName}}</td>
            <td>{{form.agentName}}</td>
            <td>{{form.reportNum}}</td>
            <td>{{form.totalFee}}</td>
            <td>{{form.feeRate}}%</td>
            <td>{{form.realFee}}</td>
            <td>{{form.publishTime}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="srcList.length > 0" style="margin: 20px 0">缴费凭证</div>
      <div v-if="srcList.length > 0" style="display: flex;justify-content: start">
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </div>
      </div>
      <div style="margin: 20px 0">费用明细</div>
      <el-table :data="form.feeInfoList" stripe size="medium">
        <el-table-column prop="specialtyName" label="专业"></el-table-column>
        <el-table-column prop="gradeName" label="级别"></el-table-column>
        <el-table-column prop="onlineEnrollNum" label="线上报名人数"></el-table-column>
        <el-table-column prop="importEnrollNum" label="导入报名人数"></el-table-column>
        <el-table-column prop="enrollTotalNum" label="报名总人数"></el-table-column>
        <el-table-column prop="singleFee" label="考级费"></el-table-column>
        <el-table-column prop="totalFee" label="实际级别报名总费用"></el-table-column>
        <el-table-column prop="feeRate" label="分账比例">
          <template slot-scope="scope">
            <span>{{scope.row.feeRate}}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="realFee" label="实际应交级别报名总费用"></el-table-column>
      </el-table>
    </div>
    <el-dialog title="审核不通过" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage"></Edit>
    </el-dialog>
  </div>
</template>

<script>
import Edit from './unpass-edit'

export default {
  name: "Information-detail",
  components: {Edit},
  props: ['row'],
  data () {
    return {
      form: {},
      srcList: [],
      editForm: { show: false, row: null }
    }
  },
  async created () {
    await this.getPage()
  },
  methods: {
    async getPage () {
      this.editForm.show = false
      this.editForm.row = null
      this.srcList = []
      this.form = await this.$HTTP.ApiExamAudit.getFeeInfo(this.$route.query.logId)
      if (this.form.voucherUrl) {
        let arry = this.form.voucherUrl.split(',')
        if (arry.length > 0) {
          for (let j in arry) {
            let img = arry[j]
            img = await this.$HTTP.ApiOss.signatureUrl(img, 'agent-data')
            this.srcList.push(img)
          }
        }
      }
    },
    async save () {
      try {
        let confirm = await this.$confirm('确定要通过审核吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let param = {
            isPass: 1,
            logId: this.$route.query.logId
          }
          await this.$HTTP.ApiExamAudit.auditReport(param)
          this.$message({ type: 'success', message: '操作成功' })
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit () {
      this.editForm.show = true
      if (this.$route.query.logId) {
        this.editForm.row = {
          logId: this.$route.query.logId
        }
      } else {
        this.editForm.row = null
      }
    }
  }
}
</script>

<style scoped>
.tab thead {
  background-color: #fafafa;
}

.tab thead tr th {
  padding: 10px;
  font-size: 14px;
  /*border-bottom: 1px solid #e6e6e6;*/
}

.tab tbody tr td {
  padding: 10px;
  font-size: 14px;
}
</style>
